import { baseLayerLuminanceSwatch } from "../utilities/base-layer-luminance.js";
/**
 * @internal
 */
export function neutralLayerFloating(palette, relativeLuminance, layerDelta) {
    const cardIndex = palette.closestIndexOf(baseLayerLuminanceSwatch(relativeLuminance)) - layerDelta;
    return palette.get(cardIndex - layerDelta);
}
